export const paths = {
    restaurants: '/restaurants',
    bars: '/restaurants',
    hotelInformation: '/hotel-info',
    roomService: '/room-service',
    experiences: '/experiencies',
    hotelActivities: '/rooms',
    kidsClub: '/',
    spa: '/spa',
    gym: '/gym',
    tours: '/tours',
    spots: '/near-spots',
    shop: '/',
    concierge: '/',
    rooms: '/rooms',
    gallery: 'gallery'
}